import { client } from "./client";
import {
  Automation, AutomationCreateRequest, AutomationUpdateRequest,
} from "../types/Automation";

export function apiCreateAutomation(
  organizationId: number,
  workspaceId: number,
  AutomationCreateRequest: AutomationCreateRequest
) {
  return client.post(
    `/organizations/${organizationId}/workspaces/${workspaceId}/automations`,
    AutomationCreateRequest
  );
}

export function apiGetAutomations(
  organizationId: number,
  workspaceId: number
) {
  return client.get(
    `/organizations/${organizationId}/workspaces/${workspaceId}/automations`
  );
}

export function apiUpdateAutomation(
  organizationId: number,
  workspaceId: number,
  automationId: number,
  automationUpdateRequest: AutomationUpdateRequest
) {
  return client.put(
    `/organizations/${organizationId}/workspaces/${workspaceId}/automations/${automationId}`,
    automationUpdateRequest
  );
}

export function apiRunAutomation(
  organizationId: number,
  workspaceId: number,
  automationId: number,
  selection: string,
  code: string
) {
  return client.post(
    `/organizations/${organizationId}/workspaces/${workspaceId}/automations/${automationId}/run`,
    { code, selection }
  );
}